import React, { useState } from "react";
import withIntl from "../../utils/withIntl";
import { Button, DialogActions, DialogContent, Divider, Grid, Typography } from "@material-ui/core";
import RepeatSetting from "./RepeatSetting";
import TimestampSetting from "./TimestampSetting";
import { useDialog } from "../Dialogs/DialogProvider";
import { makeStyles } from "@material-ui/core/styles";

const getDefaultOrderRules = (salesArea) => {
  return {
    repeated_patterns: [
      {
        numberOfDaysAhead: Math.max(salesArea.order_max_number_of_days_ahead - 1, 0),
        repeat: { minutes: salesArea.minutes_per_block },
      },
    ],
  };
};

const useStyles = makeStyles(() => ({
  root: {
    height: "90vh",
  },
}));

function TimestampOrderRules(props) {
  const classes = useStyles();
  const salesArea = props.salesArea;

  const [orderRules, setOrderRules] = useState(
    salesArea.order_rules ? { ...salesArea.order_rules } : getDefaultOrderRules(salesArea)
  );

  const [, closeDialog] = useDialog();

  return (
    <>
      <DialogContent classes={{ root: classes.root }}>
        <Grid container spacing={1}>
          <Grid item xs={12} style={{ border: "1px solid lightgrey" }}>
            <Typography variant={"h6"}>{props.intl.formatMessage({ id: "ta_merchant.minutes_per_block" })}</Typography>

            {orderRules.repeated_patterns.map((repeatedPattern, index) => (
              <>
                <RepeatSetting
                  repeatedPattern={repeatedPattern}
                  onRemove={() => {
                    let newOrderRules = { ...orderRules };
                    newOrderRules.repeated_patterns.splice(index, 1);
                    setOrderRules(newOrderRules);
                  }}
                  onChange={(newR) => {
                    let newO = { ...orderRules };
                    newO.repeated_patterns[index] = newR;
                    setOrderRules(newO);
                  }}
                />
                <Divider />
              </>
            ))}
          </Grid>
          <Grid item xs={12}>
            <Button
              variant={"outlined"}
              onClick={() => {
                let newOrderRules = { ...orderRules };
                if (newOrderRules.repeated_patterns == null) {
                  newOrderRules.repeated_patterns = [];
                }
                newOrderRules.repeated_patterns.push({
                  repeat: { minutes: 15 },
                  numberOfDaysAhead: 0,
                });
                setOrderRules(newOrderRules);
              }}
            >
              {props.intl.formatMessage({ id: "add" })}
            </Button>
          </Grid>

          <Grid item xs={12} style={{ border: "1px solid lightgrey" }}>
            <Typography variant={"h6"}>{props.intl.formatMessage({ id: "custom_date_time" })}</Typography>
            {orderRules.timestamps == null || orderRules.timestamps.length === 0 ? (
              <Typography>{props.intl.formatMessage({ id: "no_options_found" })}</Typography>
            ) : null}
            {orderRules.timestamps?.map((timestamp, index) => (
              <TimestampSetting
                timestamp={timestamp}
                onChange={(newTimestamp) => {
                  let newO = { ...orderRules };
                  newO.timestamps[index] = newTimestamp;
                  setOrderRules(newO);
                }}
                onRemove={() => {
                  let newOrderRules = { ...orderRules };
                  newOrderRules.timestamps.splice(index, 1);
                  setOrderRules(newOrderRules);
                }}
              />
            ))}

            <Grid item xs={12}>
              <Button
                variant={"outlined"}
                onClick={() => {
                  let newOrderRules = { ...orderRules };
                  if (newOrderRules.timestamps == null) {
                    newOrderRules.timestamps = [];
                  }
                  newOrderRules.timestamps.push({
                    timestamp: new Date().getTime() / 1000,
                    repeat: {},
                    numberOfDaysAhead: 0,
                  });
                  setOrderRules(newOrderRules);
                }}
              >
                {props.intl.formatMessage({ id: "add" })}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant={"outlined"}
          onClick={() => {
            props.onSave(orderRules);
          }}
        >
          {props.intl.formatMessage({ id: "save" })}
        </Button>
        <Button
          variant={"outlined"}
          onClick={() => {
            closeDialog();
          }}
        >
          {props.intl.formatMessage({ id: "cancel" })}
        </Button>
      </DialogActions>
    </>
  );
}

export default withIntl(TimestampOrderRules);
